//System
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Input } from '@angular/core';

//Services
import { SearchService } from '../../../../services/inventory/search.service';
import { ComponentHelperService } from '../../../../services/core/component-helper.service';
import { RoutesService } from '../../../../services/core/routes.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { type } from 'os';
import { SearchResult } from '../../../../models/inventory/search-result';
import { errorHandler } from '@angular/platform-browser/src/browser';
import { error } from 'util';
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";

//Models
import { SeoViewModel } from "./../../../../models/core/seo";

import { Subscription } from 'rxjs/Subscription';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector: "",
    template: ''
})

export class SearchComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private searchService: SearchService,
            private cmsComponentService: CmsComponentService,
            private activatedRoute: ActivatedRoute,
            @Inject('isBrowser') private isBrowser: boolean,
            private scriptService: ScriptService
        ) { }

    private query: string;
    private currentPageNumber: number;
    private startRow: number = 0;
    private endRow: number = 10;
    private SearchResult: any;

    subManager = new Subscription();

    ngOnInit() {
        let paramSub = this.activatedRoute.params.subscribe((params: Params) => {

            let decodedQuery = params['query'];

            var decoded = decodeURIComponent(decodedQuery)

            this.query = encodeURIComponent(decoded);

            this.currentPageNumber = params['page'];

            if (this.currentPageNumber == undefined) {
                this.currentPageNumber = 1;
                this.startRow = (this.currentPageNumber - 1) * this.endRow;
            }
            else if (this.currentPageNumber < 1) {
                this.currentPageNumber = 1;
                this.startRow = (this.currentPageNumber - 1) * this.endRow;
            }
            else {
                this.startRow = (this.currentPageNumber - 1) * this.endRow;
            }

            let header: any;
            let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
                header = result;
                let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                    if (result1.Categories) {
                        header.Categories = result1.Categories;

                    }
                });
                this.subManager.add(SideMenuData);
            });
            this.subManager.add(headDataSub);

            let catAndProdSub = this.searchService.getCategoriesAndProducts(this.query, this.startRow, this.endRow).subscribe(result => {
                this.SearchResult = result;

                if (this.isBrowser) {
                    // Creating subcomponent whith the selected template to inject
                    let subComponent = this.createSubComponent(header, this.SearchResult, this.query, this.currentPageNumber, this.endRow);

                    //injecting created component (OK)
                    this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
                }
                else {
                    //Eventually retrieving the script to append
                    if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.SearchPageId);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.SearchWithPagingPageId);
                    }
                }
            },
                err => this.handleSearchError())

            this.subManager.add(catAndProdSub);
        })

        this.subManager.add(paramSub)
    }

    handleSearchError() {
        this.query = null;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        this.searchService.getCategoriesAndProducts(this.query, this.startRow, this.endRow).subscribe(result => {
            this.SearchResult = result;
            if (this.isBrowser) {
                // Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(header, this.SearchResult, this.query, this.currentPageNumber, this.endRow);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //Eventually retrieving the script to append
                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    //-- Get head and body scripts
                    this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.SearchPageId);
                }
                else {
                    //-- Get head and body scripts
                    this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, this.scriptService.SearchWithPagingPageId);
                }
            }
        })
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }


    private createSubComponent(header: any, SearchResult: any, query: string, currentPage: number, endRow: number) {

        @Component({
            template: SearchResult.TemplateHtml
        })

        class ChildComponent implements OnInit {

            constructor
                (
                    @Inject('isBrowser') private isBrowser: boolean,
                    private routesService: RoutesService,
                    private searchService: SearchService,
                    private router: Router,
                    private seoService: SeoService,
                    private scriptService: ScriptService,
                    private _elementRef: ViewContainerRef
                ) { }

            private seoInfo: SeoViewModel = SearchResult.SeoInformation;
            private pageIsInit: boolean = false;
            private searchResults: Array<SearchResult>;
            private defaultImageUrl: string = "/global_app/img/noimage.jpg";
            private redirectUrlNone: string = "javascript:void(0)";

            //pagination
            private query = query;
            private currentPageNumber: number = currentPage;
            private disablePreviousPage: boolean = false;
            private disableNextPage: boolean = false;
            private numberOfPages: number = Math.ceil(SearchResult.NumberOfResults / endRow);
            private searchResultsPage: string[] = [];
            private searchResultsPageWithPagination: string[] = [];
            private pages: any = this.createRange(this.numberOfPages);
            private numberOfResult: number = SearchResult.NumberOfResults;
            headerData: any = header;
            ngOnInit() {
                if (SearchResult.SearchModelList != null) {
                    this.searchResults = SearchResult.SearchModelList;
                }

                if (this.currentPageNumber == 0 || this.currentPageNumber == 1) {
                    this.disablePreviousPage = true;
                }
                else if (this.currentPageNumber == this.numberOfPages) {
                    this.disableNextPage = true;
                }

                this.searchResultsPage = this.routesService.getRoutePath('SEARCH - RESULTS');
                this.searchResultsPageWithPagination = this.routesService.getRoutePath('SEARCH RESULTS - PAGINATION');

                if (this.searchResults != null && this.searchResults != undefined) {
                    for (let i = 0; i < this.searchResults.length; i++) {
                        //setting of default image if image url is not defined
                        if (this.searchResults[i].ImageUrl == null || this.searchResults[i].ImageUrl == "") {
                            this.searchResults[i].ImageUrl = this.defaultImageUrl;
                        }

                        //setting of url href not to do nothing if url is not defined
                        if (this.searchResults[i].RedirectUrl == null || this.searchResults[i].RedirectUrl == "") {
                            this.searchResults[i].RedirectUrl = this.redirectUrlNone;
                        }
                    }
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            //Pagination start
            createRange(number) {
                var items: any[] = [];

                for (var i = 1; i <= number; i++) {
                    items.push(i);
                }

                return items;
            }

            showClickedPage(index) {
                let page = index + 1;
                let url = this.searchResultsPageWithPagination[0]
                    .replace(':query', query)
                    .replace(':page', page.toString());

                this.router.navigate([url]);
            }

            showPreviousPage() {
                let previousPage: number = this.currentPageNumber - 1;

                if (previousPage > 0) {
                    let url = this.searchResultsPageWithPagination[0]
                        .replace(':query', query)
                        .replace(':page', previousPage.toString());

                    this.router.navigate([url]);
                }
            }

            showNextPage() {
                let nextPage: number = Number(this.currentPageNumber) + 1;

                if (nextPage <= this.numberOfPages) {
                    let url = this.searchResultsPageWithPagination[0]
                        .replace(':query', query)
                        .replace(':page', nextPage.toString());

                    this.router.navigate([url]);
                }
            }
            //Pagination end
        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/header/widget/search.component.ts